import { createBrowserRouter, RouterProvider } from "react-router-dom";
import courses from "./data/courses.json";
import Main from "./layouts/Main";
import Home from "./components/Home";
import Courses from "./components/Courses";
import CourseDetials from "./components/CourseDetials";
import PrivateRoute from "./routes/PrivateRoute";
import Checkout from "./components/Checkout";
import Blogs from "./components/Blogs";
import FAQ from "./components/FAQ";
import Signin from "./components/Signin";
import Signup from "./components/Signup";
import ErrorPage from "./components/ErrorPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CheckoutError from "./components/CheckoutError";

export default function App() {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <Main />,
            children: [
                {
                    path: "/",
                    element: <Home />,
                },
                {
                    path: "/courses",
                    loader: () => courses,
                    element: <Courses />,
                },
                {
                    path: "course/:id",
                    loader: ({ params }) => courses.find((course) => course.id === params.id),
                    element: <CourseDetials />,
                },
                {
                    path: "/checkout/:id",
                    loader: ({ params }) => courses.find((course) => course.id === params.id),
                    element: (
                        <PrivateRoute>
                            <Checkout />
                        </PrivateRoute>
                    ),
                },
                {
                    path: "/checkout",
                    element: <CheckoutError />,
                },
                {
                    path: "/blogs",
                    element: <Blogs />,
                },
                {
                    path: "/faq",
                    element: <FAQ />,
                },
                {
                    path: "/signin",
                    element: <Signin />,
                },
                {
                    path: "/signup",
                    element: <Signup />,
                },
                {
                    path: "/privacypolicy",
                    element: <PrivacyPolicy />,
                },
            ],
        },
        {
            path: "*",
            element: <ErrorPage />,
        },
    ]);

    return <RouterProvider router={router}></RouterProvider>;
}
